import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for PWJ503F1 (樣品交運單核准)
// ============================================================

export interface ApprovalCandidate {
  fj130_01: string; // 樣品交運單號
  fj130_11: string; // 交運日期
  fj130_12: string; // 客戶代號/名稱
  fj130_21: string; // 業務員代號/姓名
  fj130_22: string; // 部門代號/名稱
  fj130_49: string; // 費用類別
  fj130_80: string; // 核准狀態: 空白=未核准, P=已核准
}

export interface QueryResponse {
  items: ApprovalCandidate[];
  total: number;
}

export interface ApproveResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const pwj503Api = {
  /** Query sample delivery order candidates eligible for approval */
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start'] = startNo.trim();
    if (endNo.trim()) params['end'] = endNo.trim();
    const res = await apiClient.get('/api/pwj503/candidates', { params });
    return res.data;
  },

  /** Execute batch approval for selected sample delivery orders */
  async approve(items: string[]): Promise<ApproveResponse> {
    const res = await apiClient.post('/api/pwj503/approve', { items, confirmed: true });
    return res.data;
  },
};
